module.exports = __webpack_public_path__ + "img/quoteworx-logo.26c2cd9f.png";